module.exports = __webpack_public_path__ + "static/coral-reef-awareness-iii-2ecfb5e581b84c2840deb704df867bc8.jpg";